import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/layouts/default.vue"))
}